// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__xryok","notf":"NotFound_notf__Ix7Y6","explanation":"NotFound_explanation__KYZa8","goMain":"NotFound_goMain__Gje3Y"};